import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';


const STATO_COLORE = { pending: '#b45309', processing: '#2563eb', failed: '#b91c1c' };

// Coda auto-retry SSMATE: le verifiche fallite per sito-down/quota vengono ritentate da sole.
export default function SsmateCodaCard() {
  const [q, setQ] = useState({ items: [], pending: 0, processing: 0, failed: 0, worker_running: false, live_status: null });

  const load = useCallback(() => {
    axios.get(`${API}/ssmate/queue`).then((r) => setQ(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [load]);

  const forza = async () => {
    try { await axios.post(`${API}/ssmate/queue/force-retry`); toast.success('Retry forzato'); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };
  const svuota = async () => {
    if (!window.confirm('Svuotare la coda SSMATE (richieste in attesa + fallite)?')) return;
    try { await axios.delete(`${API}/ssmate/queue`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };
  const rimuovi = async (id) => {
    try { await axios.delete(`${API}/ssmate/queue/${id}`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  return (
    <div className="imp-card">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <div className="imp-card-title">Coda SSMATE (retry automatico)</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-secondary" onClick={forza} disabled={q.pending === 0}>Forza retry</button>
          <button className="btn btn-secondary" style={{ color: '#b91c1c' }} onClick={svuota}
            disabled={(q.pending + q.failed) === 0}>Svuota coda</button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 16, margin: '10px 0', fontSize: 13, flexWrap: 'wrap' }}>
        <span>In attesa: <b>{q.pending}</b></span>
        <span>In corso: <b>{q.processing}</b></span>
        <span style={{ color: q.failed ? '#b91c1c' : undefined }}>Falliti: <b>{q.failed}</b></span>
        <span style={{ color: q.worker_running ? '#15803d' : '#94a3b8' }}>
          Worker: <b>{q.worker_running ? 'attivo' : 'fermo'}</b>
        </span>
      </div>
      {q.live_status && (
        <div style={{ fontSize: 12.5, color: '#2563eb', marginBottom: 10 }}>{q.live_status}</div>
      )}

      {q.items.length === 0 ? (
        <div style={{ fontSize: 13, color: '#94a3b8' }}>Coda vuota.</div>
      ) : (
        <div style={{ maxHeight: 240, overflowY: 'auto', border: '1px solid #f1f5f9', borderRadius: 8 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#64748b', position: 'sticky', top: 0, background: 'var(--surface)' }}>
                <th style={{ padding: '6px 8px' }}>Azienda</th>
                <th style={{ padding: '6px 8px' }}>CF</th>
                <th style={{ padding: '6px 8px' }}>Stato</th>
                <th style={{ padding: '6px 8px' }}>Tentativi</th>
                <th style={{ padding: '6px 8px' }}></th>
              </tr>
            </thead>
            <tbody>
              {q.items.map((it) => (
                <tr key={it.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '6px 8px', fontWeight: 600 }}>{it.accountname || '—'}</td>
                  <td style={{ padding: '6px 8px', fontFamily: 'monospace' }}>{it.codice_fiscale}</td>
                  <td style={{ padding: '6px 8px', color: STATO_COLORE[it.status] || '#334155' }}>{it.status}</td>
                  <td style={{ padding: '6px 8px' }}>{it.retries || 0}</td>
                  <td style={{ padding: '6px 8px' }}>
                    <button className="btn btn-secondary" style={{ color: '#b91c1c' }} onClick={() => rimuovi(it.id)}>Rimuovi</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
